import React, { FC, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import Alert from '../Alert'
import ImageUploader from 'react-images-upload'
import useAxios from '../../hooks/useAxios'
import { logError, updateUserProfile } from '../../store/slices/app'
import { useDispatch } from 'react-redux'

interface Props {
  show: boolean
  onHide: () => void
}

const ProfilePicUploadModal: FC<Props> = (props) => {
  const dispatch = useDispatch()
  const [pictures, setPictures] = useState<any[] | undefined>(undefined)
  const [imageFile, setImageFile] = useState<string | undefined>()
  const [uploadStatus, setUploadStatus] = useState('')
  const [statusMsg, setStatusMsg] = useState('')
  const instance = useAxios()

  const onDrop = (picture: any) => {
    //setPictures([...pictures, picture]);
    setPictures(picture)

    if (picture && picture[0]) {
      const imageReader = new FileReader()

      imageReader.onload = (e) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        setImageFile(e.target.result)
      }

      imageReader.readAsDataURL(picture[0])
    }
  }

  const handleImageUpload = async (pictures: any) => {
    if (!pictures || uploadStatus === 'uploading') return

    setUploadStatus('uploading')
    setUploadStatus('')
    setStatusMsg('')

    const form = new FormData()
    form.append('profile_image', pictures[0])

    try {
      const response = await instance.post('ac/v1/profile-images', form, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      setUploadStatus('success')
      setStatusMsg('Profile picture updated successfully.')

      dispatch(updateUserProfile(response.data.profile))

      setPictures([])
      setImageFile('')
    } catch (e) {
      dispatch(logError(e))
      setUploadStatus('error')
      setStatusMsg('Failed to upload profile image. Please try again.')
    }
  }

  return (
    <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Upload new picture</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="user-settings-alerts mx-auto">{statusMsg && <Alert type={uploadStatus} msg={statusMsg} />}</div>
        <div className="profile-pic-preview mx-auto my-3 p-1 overflow-hidden">
          {imageFile && <img src={imageFile} alt="preview" className="mw-100" />}
        </div>
        <div className="profile-image-wrap my-5 mx-auto">
          {/* <div className="custom-file">
						<input type="file" className="custom-file-input" id="profileImage" onChange={(e) => console.log(e.target.files)} />
						<label className="custom-file-label" htmlFor="profileImage">Select image</label>
					</div> */}

          {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
          {/* @ts-ignore */}
          <ImageUploader
            {...props}
            withIcon={true}
            onChange={onDrop}
            imgExtension={['.jpg', '.gif', '.png']}
            maxFileSize={5242880}
            singleImage={true}
            buttonText="Choose image"
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
        {imageFile && (
          <button className="btn btn-secondary ml-2" onClick={() => handleImageUpload(pictures)}>
            {uploadStatus === 'uploading' && (
              <div className="spinner-border text-light mr-3" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            )}
            <span>Upload</span>
          </button>
        )}
      </Modal.Footer>
    </Modal>
  )
}

export default ProfilePicUploadModal
